////// Lib. //////
//////////////////

import * as d3 from "d3";

///// Utils //////
//////////////////

import { getCombinedGraphData } from "../utils/dataUtils.js";

///// Assets /////
//////////////////

const msgs = {
  start: ["init. graph"],
  end: ["init. graph", "init. success"],
};

/// Init. def. ///
//////////////////

export default function init_graph() {
  ///// Setup //////
  //////////////////

  const { cont_graph } = this.ref;
  const { logs } = this.options;
  if (logs) console.log(msgs.start[0]);

  // Get container dimensions
  const containerRect = cont_graph.getBoundingClientRect();
  const width = containerRect.width;
  const height = containerRect.height;

  // Clear any existing content
  d3.select(cont_graph).selectAll("*").remove();

  // Get combined graph data (hardcoded + widget data)
  const graphData = getCombinedGraphData(cont_graph);

  // Specify the color scale for different types
  const color = d3.scaleOrdinal().domain(["boss", "main", "sub", "img"]).range(["#fd6f49", "#fd6f49", "#fff38e", "#87ceeb"]);

  // Create a copy of nodes (D3 simulation mutates the data)
  const nodes = graphData.nodes.map((d) => ({ ...d }));

  /// Simulation ///
  //////////////////

  // Create a force simulation
  const simulation = d3
    .forceSimulation(nodes)
    .force("charge", d3.forceManyBody().strength(-300)) // Repulsion between nodes
    .force("x", d3.forceX().strength(0.25)) // Attraction to center on x-axis
    .force("y", d3.forceY().strength(0.25)) // Attraction to center on y-axis
    .force(
      "collision",
      d3.forceCollide().radius((d) => d.size + 2),
    );

  // Create SVG container
  const svg = d3
    .select(cont_graph)
    .append("svg")
    .attr("width", width)
    .attr("height", height)
    .attr("viewBox", [-width / 2, -height / 2, width, height])
    .style("max-width", "100%")
    .style("height", "auto")
    .style("overflow", "visible");

  // Add defs for image patterns
  const defs = svg.append("defs");

  // Create image patterns for nodes with images
  const patterns = defs
    .selectAll("pattern")
    .data(nodes.filter((d) => d.type === "img" && d.url_quoteImg))
    .enter()
    .append("pattern")
    .attr("id", (d) => `pattern-node-img-${d.id}`)
    .attr("x", "-5%")
    .attr("y", "-5%")
    .attr("width", "110%")
    .attr("height", "110%")
    .attr("viewBox", "0 0 1 1")
    .attr("preserveAspectRatio", "xMidYMid slice");

  patterns
    .append("image")
    .attr("x", 0)
    .attr("y", 0)
    .attr("width", 1)
    .attr("height", 1)
    .attr("href", (d) => d.url_quoteImg);

  // Create nodes
  const node = svg
    .append("g")
    .selectAll("circle")
    .data(nodes)
    .join("circle")
    .attr("r", (d) => d.size / 2)
    .attr("fill", (d) => {
      // Use image pattern if available for img type nodes, otherwise use color
      if (d.type === "img" && d.url_quoteImg) return `url(#pattern-node-img-${d.id})`;
      return color(d.type);
    })
    .attr("stroke", "#000")
    .attr("stroke-width", 1)
    .style("cursor", "grab");

  // Add titles (tooltips)
  node.append("title").text((d) => d.name);

  // Add labels for "main" type nodes
  // const labels = svg
  //   .append("g")
  //   .selectAll("text")
  //   .data(nodes.filter((d) => d.type === "main"))
  //   .join("text")
  //   .text((d) => d.name)
  //   .attr("text-anchor", "middle")
  //   .attr("dominant-baseline", "middle")
  //   .attr("fill", "#000")
  //   .attr("font-size", "12px")
  //   .attr("font-weight", "bold")
  //   .style("pointer-events", "none"); // Prevent labels from interfering with node interactions

  // Add drag behavior
  node.call(d3.drag().on("start", dragstarted).on("drag", dragged).on("end", dragended));

  // Update positions on each simulation tick
  simulation.on("tick", () => {
    node.attr("cx", (d) => d.x).attr("cy", (d) => d.y);
    // labels.attr("x", (d) => d.x).attr("y", (d) => d.y);
  });

  // Draggability //
  //////////////////

  // Drag event handlers
  function dragstarted(event) {
    if (!event.active) simulation.alphaTarget(0.3).restart();
    event.subject.fx = event.subject.x;
    event.subject.fy = event.subject.y;
    d3.select(this).style("cursor", "grabbing");
  }

  function dragged(event) {
    event.subject.fx = event.x;
    event.subject.fy = event.y;
  }

  function dragended(event) {
    if (!event.active) simulation.alphaTarget(0);
    event.subject.fx = null;
    event.subject.fy = null;
    d3.select(this).style("cursor", "grab");
  }

  //// Conclude ////
  //////////////////

  if (logs) console.log(msgs.end[0], "→", msgs.end[1]);
}
